<template>
	<div ref="date_picker" class="dropdown-select date-picker">{{ dateText }}</div>
</template>

<script>
import moment from 'moment';

export default {
	props: {
		date: String,
		mode: {
			type: String,
			required: true,
		},
		referenceDate: String,
	},

	computed: {
		dateText() {
			return this.formatDateText(this.date, this.mode);
		},
	},

	mounted() {
		this.initDatePicker();
	},

	watch: {
		date: 'initDatePicker',
		referenceDate(newVal) {
			if (newVal && this.mode === 'to') {
				this.initDatePicker();
			}
		},
	},

	methods: {
		initDatePicker() {
			const element = this.$refs.date_picker;

			const startDate = this.getStartDate(this.date, this.mode, this.referenceDate);
			const minDate = this.getMinDate(this.mode, this.referenceDate);
			const maxDate = this.getMaxDate(this.mode, this.referenceDate);

			$(element).daterangepicker({
				singleDatePicker: true,
				alwaysShowCalendars: true,
				opens: 'center',
				showDropdowns: true,
				startDate,
				minDate,
				maxDate,
			});

			$(element).on('apply.daterangepicker', (ev, picker) => {
				this.updateDate(picker.startDate);
			});
		},

		updateDate(selectedDate) {
			this.$emit('update-date', selectedDate.format('YYYY-MM-DD'));
		},

		formatDateText(date, mode) {
			if (this.isValidDate(date)) {
				return this.formatDate(date);
			}
			return this.getDefaultDateText(mode);
		},

		getStartDate(date, mode, referenceDate) {
			if (this.isValidDate(date)) {
				return moment(date);
			}
			return this.getDefaultStartDate(mode, referenceDate);
		},

		getMinDate(mode, referenceDate) {
			return mode === 'from'
				? moment('2000-01-01')
				: moment(referenceDate).subtract(31, 'days');
		},

		getMaxDate(mode, referenceDate) {
			if (mode === 'from') {
				return moment();
			}

			const maxPossibleDate = moment(referenceDate).add(31, 'days');
			return this.isAfterToday(maxPossibleDate) ? moment() : maxPossibleDate;
		},

		isValidDate(date) {
			return date != null && moment(date).isValid();
		},

		isAfterToday(date) {
			return date.isAfter(moment());
		},

		formatDate(date) {
			return moment(date).format('Do [of] MMMM YYYY');
		},

		getDefaultDateText(mode) {
			if (mode === 'from') {
				return __('From Date');
			}
			return __('To Date');
		},

		getDefaultStartDate(mode, referenceDate) {
			if (mode === 'from') {
				return moment();
			}
			return moment(referenceDate);
		},
	},
};
</script>
